import { Modal, ModalBody, ModalDescription, ModalHeader, ModalTitle } from "@/ds/custom/Modal";
import { Spinner } from "@/ds/shadcn/components/ui/spinner";
import { MfaCodeInput } from "@/features/common/components/MfaCodeInput";
import { ErrorDisplay } from "@/lib/common/ErrorDisplay";
import { useFocus } from "@/lib/common/useFocus";
import type { ProblemResponse } from "@/lib/http";
import { useEffect, useState, type FC } from "react";

export interface ModalMfaProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onConfirmed: (mfaCode: string) => void;
	isLoading?: boolean;
	error?: ProblemResponse | null;
}

export const ModalMfa: FC<ModalMfaProps> = props => {
	const {
		open,
		onOpenChange,
		onConfirmed,
		isLoading = false,
		error
	} = props;

	const [ref, focus] = useFocus();
	const [mfaCode, setMfaCode] = useState("");

	useEffect(() => {
		if (mfaCode.length !== 6 || isLoading) {
			return;
		}

		onConfirmed(mfaCode);
	}, [mfaCode]);

	useEffect(() => {
		if (!error) {
			return;
		}

		setMfaCode("");
		setTimeout(() => focus(), 100);
	}, [error]);

	useEffect(() => {
		if (!open) {
			return;
		}

		setTimeout(() => focus(), 100);
	}, [open]);

	return (
		<Modal preventCloseOnInteractOutside={true} open={open} onOpenChange={onOpenChange}>
			<ModalHeader>
				<ModalTitle>Multi-Factor Authentication</ModalTitle>
				<ModalDescription>
					Please provide your multi-factor authentication code
				</ModalDescription>
			</ModalHeader>
			<ModalBody>
				<div className="flex flex-col justify-center items-center gap-4">
					<MfaCodeInput ref={ref} value={mfaCode} onChange={setMfaCode} disabled={isLoading} />

					{
						isLoading && <Spinner />
					}

					<ErrorDisplay subtle error={error} />
				</div>
			</ModalBody>
		</Modal>
	);
};
